import { render, staticRenderFns } from "./ChangeUserProfilePictureModal.vue?vue&type=template&id=c15d2108&"
import script from "./ChangeUserProfilePictureModal.vue?vue&type=script&lang=js&"
export * from "./ChangeUserProfilePictureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports